import { graphql, useStaticQuery } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";

import { ModalType } from "../state/ModalProvider";

import BasicModal from "./BasicModal";

const PageNotAvailableInProvinceModal = () => {
  const { locale } = useIntl();
  const { en, fr } = useStaticQuery(query);
  const data = locale === 'fr' ? fr : en;

  return (
    <BasicModal
      data={data}
      type={ModalType.PAGE_NOT_AVAILABLE_IN_PROVINCE}
    />
  );
};

const query = graphql`
  query {
    en: contentfulModal(
      modalType: { eq: "PAGE_NOT_AVAILABLE_IN_PROVINCE" }
      node_locale: { eq: "en-CA" }
    ) {
      ...Modal  
    }
    fr: contentfulModal(
      modalType: { eq: "PAGE_NOT_AVAILABLE_IN_PROVINCE" }
      node_locale: { eq: "fr-CA" }
    ) {
      ...Modal  
    }
  }
`;

export default PageNotAvailableInProvinceModal;
